import Icon from '../components/Icon.vue'

Icon.register({"subway":{"width":448,"height":512,"paths":[{"d":"M448 96V352C448 403.8 386.4 448 318 448L381 497.7C386.9 502.4 383.6 512 376 512H72C64.4 512 61.1 502.4 67 497.7L130 448C61.8 448 0 404 0 352V96C0 43 64 0 128 0H320C385 0 448 43 448 96zM200 232V120C200 106.7 189.3 96 176 96H72C58.7 96 48 106.7 48 120V232C48 245.3 58.7 256 72 256H176C189.3 256 200 245.3 200 232zM400 232V120C400 106.7 389.3 96 376 96H272C258.7 96 248 106.7 248 120V232C248 245.3 258.7 256 272 256H376C389.3 256 400 245.3 400 232zM352 288C325.5 288 304 309.5 304 336S325.5 384 352 384 400 362.5 400 336 378.5 288 352 288zM96 288C69.5 288 48 309.5 48 336S69.5 384 96 384 144 362.5 144 336 122.5 288 96 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/subway.js
// module id = iRPT
// module chunks = 0